let sprites = {
  StartButton: {
    el: "button",
    type: "image",
    states: {
      normal: {
        src: "images/StartButt1.png"
      },
      hover: {
        src: "images/StartButt2.png"
      },
      click: {
        src: "images/StartButt3.png"
      }
    },
    events: {
      pointerup: "hover",
      mouseenter: "hover",
      click: "click",
      mouseleave: "normal",
      pointerdown: "click"
    },
    initialState: "normal"
  },
  shorts: {
    el: "span",
    type: "image",
    states: {
      buried: {
        src: "images/Shorts1.png"
      },
      dragging: {
        src: "images/Shorts2.png"
      }
    },
    initialState: "buried"
  },
  shirt: {
    el: "span",
    type: "image",
    states: {
      buried: {
        src: "images/Shirt1.png"
      },
      dragging: {
        src: "images/Shirt2.png"
      }
    },
    initialState: "buried"
  },
  sandals: {
    el: "span",
    type: "image",
    states: {
      buried: {
        src: "images/Sandals1.png"
      },
      dragging: {
        src: "images/Sandals2.png"
      }
    },
    initialState: "buried"
  },
  hat: {
    el: "span",
    type: "image",
    states: {
      buried: {
        src: "images/Hat1.png"
      },
      dragging: {
        src: "images/Hat2.png"
      }
    },
    initialState: "buried"
  },
  sunglasses: {
    el: "span",
    type: "image",
    states: {
      buried: {
        src: "images/Shades1.png"
      },
      dragging: {
        src: "images/Shades2.png"
      }
    },
    initialState: "buried"
  },
  CCButton: { // stored for preloading only
    el: "span",
    type: "image",
    states: {
      off: {
        src: "images/CCButt2.png"
      },
      on: {
        src: "images/CCButt1.png"
      }
    }
  },
  muteButton: { // stored for preloading only
    el: "span",
    type: "image",
    states: {
      off: {
        src: "images/MuteButt1.png"
      },
      on: {
        src: "images/MuteButt2.png"
      }
    }
  },
  jetpackBG: { // stored for preloading only
    el: "span",
    type: "image",
    states: {
      normal: {
        src: "images/JetPackBG.png"
      }
    }
  },
  jetpack: {
    el: "span",
    type: "image",
    states: {
      buried: {
        src: "images/JetPack1.png"
      },
      dragging: {
        src: "images/JetPack2.png"
      }
    },
    initialState: "buried"
  },
  Santa: {
    el: "span",
    type: "image",
    states: {
      nothing: {
        src: "images/Santa1.gif"
      },
      shorts: {
        src: "images/Santa2.gif"
      },
      shirt: {
        src: "images/Santa3.gif"
      },
      sandals: {
        src: "images/Santa4.gif"
      },
      hat: {
        src: "images/Santa5.gif"
      },
      sunglasses: {
        src: "images/Santa6.gif"
      },
      complete: {
        src: "images/Santa7.gif"
      }
    },
    events: {
    },
    initialState: "nothing"
  },
  LaunchButton: {
    el: "button",
    type: "image",
    states: {
      normal: {
        src: "images/LaunchButt1.png"
      },
      hover: {
        src: "images/LaunchButt2.png"
      },
      click: {
        src: "images/LaunchButt3.png"
      }
    },
    initialState: "normal"
  },
  OrangeButton: {
    el: "button",
    type: "image",
    states: {
      normal: {
        src: "images/OrangeButt1.png"
      },
      hover: {
        src: "images/OrangeButt2.png"
      },
      click: {
        src: "images/OrangeButt3.png",
        sound: "round2/sfx_button1"
      },
      glow: {
        src: "images/OrangeButt2.png",
        sound: "round2/sfx_button1"
      }
    },
    events: {
      pointerup: "normal",
      pointerdown: "click",
      touchstart: "click",
      touchend: "normal"
    },
    initialState: "normal"
  },
  GreenButton: {
    el: "button",
    type: "image",
    states: {
      normal: {
        src: "images/GreenButt1.png"
      },
      hover: {
        src: "images/GreenButt2.png"
      },
      click: {
        src: "images/GreenButt3.png",
        sound: "round2/sfx_button2"
      },
      glow: {
        src: "images/GreenButt2.png",
        sound: "round2/sfx_button2"
      }
    },
    events: {
      pointerup: "normal",
      pointerdown: "click",
      touchstart: "click",
      touchend: "normal"
    },
    initialState: "normal"
  },
  PurpleButton: {
    el: "button",
    type: "image",
    states: {
      normal: {
        src: "images/PurpleButt1.png"
      },
      hover: {
        src: "images/PurpleButt2.png"
      },
      click: {
        src: "images/PurpleButt3.png",
        sound: "round2/sfx_button3"
      },
      glow: {
        src: "images/PurpleButt2.png",
        sound: "round2/sfx_button3"
      }
    },
    events: {
      pointerup: "normal",
      pointerdown: "click",
      touchstart: "click",
      touchend: "normal"
    },
    initialState: "normal"
  },
  BlueButton: {
    el: "button",
    type: "image",
    states: {
      normal: {
        src: "images/BlueButt1.png"
      },
      hover: {
        src: "images/BlueButt2.png"
      },
      click: {
        src: "images/BlueButt3.png",
        sound: "round2/sfx_button4"
      },
      glow: {
        src: "images/BlueButt2.png",
        sound: "round2/sfx_button4"
      }
    },
    events: {
      pointerup: "normal",
      pointerdown: "click",
      touchstart: "click",
      touchend: "normal"
    },
    initialState: "normal"
  }
}

export {sprites}
